import { useView } from '@10000/react'
import { uuid } from '@10000/common'
import { AddPill, Avatar, Body, Box, ItemPill } from '../../widgets'
import { subscriptions } from '../../../lookups'

export const TeamSelect = ({ organisationId, onTeamSelected }) => {
  const { teams, subscription } = useView('tenant')
  const organisationTeams = teams.filter(team => team.organisation === organisationId) || []

  return (
    <Box gap={8} column>
      <Body alt bold>Teams</Body>
      {organisationTeams.map(({ name, avatar, id }, index) =>
        <ItemPill
          action={avatar === undefined}
          index={index}
          key={index}
          blackListBackgrounds={['white']}
          onClick={() => onTeamSelected(id)}
        >
          <Box fullWidth alignItems="center" gap={8}>
            <Avatar size="small" index={avatar} mode="team"/>
            <Box fullWidth>
              <Body bold align="left">{name ? name : 'Unnamed Team'}</Body>
            </Box>
            <Body underline alt bold size={12}>Edit</Body>
          </Box>
        </ItemPill>
      )}
      {(subscriptions[subscription.index]?.teamLimit || 0) > teams.length && (
        <AddPill text="Add new" onClick={() => onTeamSelected(uuid())}/>
      )}
    </Box>
  )
}

